import React from "react";
import { foodCategories } from "./menuData";

const MenuCategorySelector = ({ foodInfo, templateId, foodId, onSelectCategory }) => {
  if (templateId === "1" && foodId === null) {
    return foodInfo
      .filter((d) => d.foodTitle !== "Wings")
      .map((category, index) => (
        <div
          className="col-md-4 text-center"
          data-aos="fade-top"
          key={index}
          onClick={() => onSelectCategory(index)}
        >
          <div className="chooseFoodContainer">
            <div className="overlay">
              <h2>{category.foodTitle}</h2>
              <img src={category.foodImage} alt={category.alt} />
              <div className="content"></div>
            </div>
          </div>
        </div>
      ));
  } else if (templateId === "2" && foodId === null) {
    return foodInfo.map((category, index) => (
      <div
        className="col-md-4 text-center"
        data-aos="fade-top"
        key={index}
        onClick={() => onSelectCategory(index)}
      >
        <div className="chooseFoodContainer">
          <div className="overlay">
            <h2>{category.foodTitle}</h2>
            <img src={category.foodImage} alt={category.alt} />
            <div className="content"></div>
          </div>
        </div>
      </div>
    ));
  }
  return null;
};

export default MenuCategorySelector;


